import {
  usePackageCarsAvailabilityPage,
  usePackageCarsAvailabilityPageRoute,
} from "./hooks";
import { PackageCarsAvailabilityPageWrapper } from "./PackageCarsAvailabilityPage.wrapper";

export const PackageCarsAvailabilityPageRoute = () => {
  const search = usePackageCarsAvailabilityPageRoute();
  const data = usePackageCarsAvailabilityPage({ search });
  return <PackageCarsAvailabilityPageWrapper {...data} />;
};
